import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Responsive, Modal, Image } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

import NavBarDesktop from './NavBarDesktop';
import NavBarChildren from './NavBarChildren';
import NavBarMobile from './NavBarMobile';
import OJKImage from '../../resources/OJKShort.png';

import messages from './messages';

export default class NavBar extends Component {
  constructor(props, context) {
    super(props, context);
  }

  static propTypes = {
    children: PropTypes.node
  };

  state = {
    visible: false,
    showTKB: false
  };

  handlePusher = () => {
    const { visible } = this.state;
    if (visible) this.setState({ visible: false });
  };

  handleToggle = () => this.setState({ visible: !this.state.visible });

  onTKB = () => this.setState({ showTKB: true });

  renderModal = () => (
    <Modal
      open={this.state.showTKB}
      centered={true}
      closeIcon
      onClose={() => {
        this.setState({ showTKB: false });
      }}
    >
      <div className="modal-wrap">
        <Image src={OJKImage} size="small" centered />
        <FormattedMessage {...messages['modalParagraph']} />
        <br />
        <FormattedMessage {...messages['modalLine1']} />
        <br />
        <FormattedMessage {...messages['modalLine2']} />
        <br />
        <span className="tkb90">TKB90=100% - NPL90</span>
        <br />
        <FormattedMessage {...messages['modalLine3']} />
        <br />
        <div className="tkb-calculation">
          <div className="divider">
            <div className="top"> <FormattedMessage {...messages['modalFormula1']} /></div>
            <div className="bottom"> <FormattedMessage {...messages['modalFormula2']} /></div>
          </div>
          <div>x 100%</div>
        </div>
      </div>
    </Modal>
  );

  render() {
    const leftItems = [
      {
        content: 'home',
        href: '/',
        translate: true,
        icon: 'home',
        key: 'home'
      },
      {
        content: 'lend',
        href: '/lend',
        translate: true,
        icon: 'handshake outline',
        key: 'lend'
      },
      {
        content: 'borrow',
        href: '/borrow',
        translate: true,
        icon: 'money bill outline',
        key: 'borrow'
      },
      {
        content: 'aboutUs',
        href: '/aboutUs',
        translate: true,
        icon: 'info circle',
        key: 'aboutUs'
      },
      {
        content: 'faq',
        href: '/faq',
        translate: true,
        icon: 'question circle outline',
        key: 'faq'
      }
    ];
    const rightItems = [
      {
        content: 'logIn',
        href: '/redirect',
        translate: true,
        redirect: 'http://116.206.196.17:4200/',
        key: 'login',
        buttonColor: '#d2ab67'
      }
    ];

    const { children } = this.props;
    const { visible } = this.state;

    return (
      <div>
        <Responsive maxWidth={Responsive.onlyTablet.maxWidth}>
          <NavBarMobile
            leftItems={leftItems}
            onPusherClick={this.handlePusher}
            onToggle={this.handleToggle}
            rightItems={rightItems}
            visible={visible}
            onTkb={this.onTKB}
          >
            <NavBarChildren>{children}</NavBarChildren>
          </NavBarMobile>
        </Responsive>

        <Responsive minWidth={Responsive.onlyComputer.minWidth}>
          <NavBarDesktop
            leftItems={leftItems}
            rightItems={rightItems}
            onTkb={this.onTKB}
          />
          <NavBarChildren>{children}</NavBarChildren>
        </Responsive>

        {this.renderModal()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js